
import React, { useEffect, useState } from 'react'
import './notification.css'
import { MDBAccordion, MDBAccordionItem, MDBBtn } from 'mdb-react-ui-kit';
import { Navigate, useNavigate } from 'react-router-dom';
import Nav from '../../globalComponents/nav/Nav';
import Footer from '../../globalComponents/footer/Footer';
import Url from '../url'

function Notification() {
    const navigate = useNavigate()
    const [token, setToken] = useState(null)
    const [projects, setProjects] = useState(null)
    const [tokenLoaded, setTokenLoaded] = useState(false)
    const [currentUserId, setCurrentUserId] = useState(undefined)
    const [currentUserEmail, setCurrentUserEmail] = useState(undefined)
    const [displayProjects, setDisplayProjects] = useState(false)
    const [admin, setAdmin] = useState(null)
    

    useEffect(() => {
        if (localStorage.getItem("user")) {

            //setCurrentUserEmail(localStorage.getItem("user"))
            localStorage.getItem("token")[3] == "Y" ? setAdmin(true) : setAdmin(false)
            setToken(localStorage.getItem("token").slice(0, 3) + localStorage.getItem("token").slice(4))
            setTokenLoaded(true)
        }
        else {//TODO if localstorage user not found redirect to "/"
            console.log(`user local storage not found`)
        }
    }, [])

    useEffect(() => {
        console.log(token)
        let url = `/api/project/notification`
        if (tokenLoaded) {
            fetch(Url+'project/notification', {
                method: "GET",
                headers: new Headers({
                    "Content-Type": "application/json",
                    "authorization": token
                })
            })
                .then(res => res.json())
                .then(data => {
                    if (data.error) { 
                        console.log("Data here")
                        console.log(data.error)
                    }
                    else{
                        setProjects(data.response)
                        console.log(data.response)
                        setDisplayProjects(true)
                    }

                })
                .catch(err => console.log(err))
        }

    }, [tokenLoaded])

    function approveDeny(projectId,finisherId,status,finisherName) {
    
        if (tokenLoaded) {
            console.log(projectId,finisherId,status)
            fetch(Url+'project/updateProjectStatus', {
                method: "POST",
                body:
                    JSON.stringify({ status, projectId: projectId, projectFinisher:finisherId })
                ,
                headers: new Headers({
                    "Content-Type": "application/json",
                    "authorization": token
                })
            })
                .then(res => res.json())
                .then(data => {
                    console.log(data)
                    if(data.error) {
                        alert(data.error)
                    } else {
                        console.log("Data here", data)
                        status == "available" 
                            ? alert(`You Denied ${finisherName}'s claim to complete this project!`)
                            : alert(`You Approved ${finisherName}'s claim to complete this project!`)
                        setDisplayProjects(true)
                        navigate('/viewAllProjects')
                    }
                    
                })
                .catch(err => console.log(err))
        }
    }

    return (
        <>
        <Nav token={token} admin={admin} email={currentUserEmail}></Nav>
                <div className='container-lg' style={{marginTop:"120px"}}>
                <h2>Pending projects:</h2>
                    <MDBAccordion initialActive={0} alwaysOpen>
                        {
                            displayProjects ? projects.map((item, key) => {
                                return (
                                        <MDBAccordionItem collapseId={key+1} 
                                            key={item.project._id}
                                            headerTitle={
                                                <div className='container-lg '>
                                                    <div className='col-md-4'>
                                                        <strong>{item.project.projectName} </strong><small> - pending</small>
                                                    </div>

                                                </div>
                                            }>
                                                
                                            <div className='row pb-4'>
                                                    
                                                <div className='col-md-5 pb-4'>
                                                    <p><small><i>Project owner: </i></small><a href="" onClick={e=>navigate(`/userProfile/${item.owner._id}`)}>{item.owner.fName} {item.owner.lName}</a></p>
                                                    <p><small><i>Email: </i></small> 
                                                    <a target="_blank" rel="nofollow" href={'mailto:'+item.owner.email}>
                                                            {item.owner.email} 
                                                    </a></p>
                                                    <p><small><i>Location: </i></small>{item.owner.country == "us" ? "United States / "+item.owner.state : item.owner.country}</p>
                                                        <button className='btn btn-info' onClick={e=>{navigate(`/viewProject/${item.project._id}`)}}>View Project</button>
                                            
                                                </div>
                                                <div className='col-md-5'>
                                                    <p><small><i>Project finisher: </i></small><a href="" onClick={e=>navigate(`/userProfile/${item.finisher._id}`)}>{item.finisher.fName} {item.finisher.lName}</a></p>
                                                    <p><small><i>Email: </i></small>
                                                    <a target="_blank" rel="nofollow" href={'mailto:'+item.finisher.email}>
                                                    {item.finisher.email}
                                                    </a></p>
                                                    <p><small><i>Location: </i></small>{item.finisher.country == "us" ? "United States / "+item.finisher.state : item.finisher.country}</p>
                                                    
                                                </div>
                                                <div className='row'>
                                                    <div className='col-md-5'>
                                                    <button className='btn-lg btn-success' 
                                                        onClick={e=>{
                                                            approveDeny(item.project._id,item.finisher._id,"claimed",item.finisher.fName+" "+item.finisher.lName)
                                                            }}>Approve</button>
                                                    </div>
                                                    <div className='col-md-5'>
                                                    <button className='btn-lg btn-danger' 
                                                        onClick={e=>{approveDeny(item.project._id,item.finisher._id,"available",item.finisher.fName+" "+item.finisher.lName)}}>Deny</button>
                                                    
                                                    </div>
                                                </div>
                                            </div>
                                        </MDBAccordionItem>
                                    

                                )
                            }) : <h1>here false</h1>
                        }
                    
                    </MDBAccordion>
                </div>
            

            <div style={{marginTop:"400px"}}>

            </div>
            <Footer></Footer>
        </>
    )
}



export default Notification